import BoltIcon from '@mui/icons-material/Bolt';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import TvIcon from '@mui/icons-material/Tv';
import React from 'react';
import { TaskType } from 'types/flows';

type Props = {
	// eslint-disable-next-line react/require-default-props
	taskType?: string;
	color: string;
};

export default ({ taskType, color }: Props) => {
	switch (taskType) {
		case TaskType.screen:
			return <TvIcon sx={{ color }} />;
		case TaskType.condition:
			return <CallSplitIcon sx={{ color }} />;
		case TaskType.automated:
		default:
			return <BoltIcon sx={{ color }} />;
	}
};
